import { render, staticRenderFns } from "./bmi-content.vue?vue&type=template&id=0c7adbda&scoped=true&"
import script from "./bmi-content.vue?vue&type=script&lang=js&"
export * from "./bmi-content.vue?vue&type=script&lang=js&"
import style0 from "./bmi-content.vue?vue&type=style&index=0&id=0c7adbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7adbda",
  null
  
)

export default component.exports